<div class="pdf-container relative" #drawerContainer>
    <p-button (click)="visible = !visible" icon="pi pi-bars" class="absolute top-2 left-2 z-30" />

    <p-drawer [(visible)]="visible" [modal]="false" [closeOnEscape]="true" [style]="{width: '350px'}">
        <ng-template pTemplate="header">
            <h3 class="text-base-300 text-lg font-bold">Table of Contents</h3>
        </ng-template>
        <div class="bg-white">
            <ul class="space-y-1">
                @for(item of outline; track item.title) {
                <li class="py-1">
                    <button 
                        (click)="pdfViewer.pdfLinkService.goToDestination(item.dest)"
                        class="w-full text-left px-2 rounded hover:bg-base-300/10 transition-colors text-base-300 font-semibold">
                        {{ item.title || "Untitled section" }}
                    </button>
                    @if(item.items?.length) {
                    <ul class="ml-4 mt-1 space-y-1">
                        @for(it of item.items; track it.title) {
                        <li>
                            <button 
                                (click)="pdfViewer.pdfLinkService.goToDestination(it.dest)" 
                                class="w-full text-left px-2 rounded hover:bg-base-300/10 transition-colors text-base-300 text-sm">
                                {{ it.title || "Untitled section" }}
                            </button>
                        </li>
                        }
                    </ul>
                    }
                </li>
                }
            </ul>
        </div>
    </p-drawer>
    
    
    <div class="w-full">
        <pdf-viewer #pdfViewer [src]="src" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="false" [zoom]="1"
            [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true" [external-link-target]="'blank'"
            [autoresize]="true" [show-borders]="false" (after-load-complete)="afterLoadComplete($event)"
            style="width: 100%; height: 43.5vh;"></pdf-viewer>
    </div>
</div>